import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Aguardando from '../common/template/aguardando';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import TBody from '../common/table/tBody';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import Td from '../common/table/td';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { getLista as getListaCargas } from '../carga/cargaActions';
import { getLista as getListaSolicitacoes } from '../solicitacao/solicitacaoActions';

class Dashboard extends Component {

	componentDidMount() {
		this.carregar();
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.usuarioCarregado && this.props.usuarioCarregado) {
			this.carregar();
		}
	}

	carregar() {
		if (this.props.getPermissao('cargas')) {
			this.props.getListaCargas();
		}
		if (this.props.getPermissao('solicitacao')) {
			this.props.getListaSolicitacoes();
		}
	}

	solicitacoesHoje() {
		const hoje = DateFormat.getDataAtual();
		return (this.props.listaSolicitacoes || [])
			.filter(item => this.somenteData(item.datahora_inclusao) === hoje)
			.sort((a, b) => Number(a.id) - Number(b.id));
	}

	somenteData(valor) {
		return String(valor || '').split('T')[0].split(' ')[0].replace(/-/g, '/');
	}

	cargasHoje() {
		const hoje = DateFormat.getDataAtual();
		const prioridade = { EM_PRODUCAO: 1, NAO_INICIADA: 2, FINALIZADA: 3 };

		return (this.props.listaCargas || [])
			.filter(item => this.somenteData(item.data_agendamento) === hoje)
			.sort((a, b) => {
				const status = (prioridade[a.status_producao] || 9) - (prioridade[b.status_producao] || 9);
				return status || Number(a.id) - Number(b.id);
			});
	}

	status(carga) {
		if (carga.status_producao === 'EM_PRODUCAO') {
			return { texto: 'Em produção', classe: 'badge badge-warning' };
		}
		if (carga.status_producao === 'FINALIZADA') {
			return { texto: 'Finalizada', classe: 'badge badge-success' };
		}
		return { texto: 'Não iniciada', classe: 'badge badge-secondary' };
	}

	card(titulo, valor, icone, cor) {
		return (
			<div className='col-6 col-lg'>
				<div className='info-box' style={{ minHeight: 88 }}>
					<span className={`info-box-icon bg-${cor}`}><i className={icone}></i></span>
					<div className='info-box-content'>
						<span className='info-box-text'>{titulo}</span>
						<span className='info-box-number' style={{ fontSize: 26 }}>{valor}</span>
					</div>
				</div>
			</div>
		);
	}

	render() {
		const cargas = this.cargasHoje();
		const solicitacoes = this.solicitacoesHoje();
		const naoIniciadas = cargas.filter(item => item.status_producao === 'NAO_INICIADA').length;
		const emProducao = cargas.filter(item => item.status_producao === 'EM_PRODUCAO').length;
		const finalizadas = cargas.filter(item => item.status_producao === 'FINALIZADA').length;

		return (
			<Content>
				<Aguardando aguardando={this.props.aguardando} />

				<div className='d-flex flex-wrap justify-content-between align-items-center mb-2'>
					<div>
						<h4 className='mb-0'>Produção de hoje</h4>
						<small className='text-muted'>{DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())}</small>
					</div>
					<div>
						{this.props.getPermissao('producao_carga') &&
						<button className='btn btn-primary mr-2' onClick={() => this.props.history.push('/producaoCarga')}>
							<i className='fas fa-barcode mr-1'></i> Executar produção
						</button>}
						<button className='btn btn-outline-secondary' onClick={() => this.carregar()}>
							<i className='fas fa-sync-alt mr-1'></i> Atualizar
						</button>
					</div>
				</div>

				{this.props.getPermissao('cargas') ? (
					<>
						<div className='row'>
							{this.props.getPermissao('solicitacao') &&
							this.card('Solicitações do dia', solicitacoes.length, 'fas fa-list-ol', 'primary')}
							{this.card('Cargas do dia', cargas.length, 'fas fa-truck-loading', 'info')}
							{this.card('Não iniciadas', naoIniciadas, 'fas fa-clock', 'secondary')}
							{this.card('Em produção', emProducao, 'fas fa-cogs', 'warning')}
							{this.card('Finalizadas', finalizadas, 'fas fa-check', 'success')}
						</div>

						<ContentCard>
							<ContentCardHeader>
								<h3 className='card-title' style={{ fontWeight: 'bold' }}>Cargas de hoje</h3>
							</ContentCardHeader>
							<ContentCardBody>
								<Table responsive border striped>
									<THead>
										<Tr>
											<Th width={80} alignCenter>Carga</Th>
											<Th width={120} alignCenter>Situação</Th>
											<Th width={100} alignCenter>Produções</Th>
											<Th width={120} alignCenter>Veículo</Th>
											<Th width={300} alignCenter>Motorista</Th>
											<Th width={150} alignCenter>Início</Th>
											<Th width={150} alignCenter>Término</Th>
										</Tr>
									</THead>
									<TBody>
										{cargas.map(carga => {
											const status = this.status(carga);
											return (
												<Tr key={carga.id}>
													<Td alignCenter bold>{carga.id}</Td>
													<Td alignCenter><span className={status.classe}>{status.texto}</span></Td>
													<Td alignCenter>{carga.quantidade_producoes || 0}</Td>
													<Td alignCenter>{carga.placa_veiculo || '-'}</Td>
													<Td alignCenter>{carga.nome_motorista || '-'}</Td>
													<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(carga.datahora_inicio_producao_log) || '-'}</Td>
													<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(carga.datahora_fim_producao_log) || '-'}</Td>
												</Tr>
											);
										})}
										{!cargas.length &&
										<Tr><Td colSpan={7} alignCenter>Nenhuma carga programada para hoje.</Td></Tr>}
									</TBody>
								</Table>
							</ContentCardBody>
						</ContentCard>

						{this.props.getPermissao('solicitacao') &&
						<ContentCard>
							<ContentCardHeader>
								<h3 className='card-title' style={{ fontWeight: 'bold' }}>Solicitações incluídas hoje</h3>
							</ContentCardHeader>
							<ContentCardBody>
								<Table responsive border striped>
									<THead>
										<Tr>
											<Th width={90} alignCenter>Solicitação</Th>
											<Th width={300} alignCenter>Parceiro</Th>
											<Th width={300} alignCenter>Ração</Th>
											<Th width={140} alignCenter>Quantidade</Th>
											<Th width={150} alignCenter>Situação</Th>
										</Tr>
									</THead>
									<TBody>
										{solicitacoes.map(item => (
											<Tr key={item.id}>
												<Td alignCenter bold>{item.id}</Td>
												<Td alignCenter>{item.nome_parceiro}</Td>
												<Td alignCenter>{item.nome_racao}</Td>
												<Td alignCenter>{FormatUtils.formatarValorTela(item.quantidade, 0)} {item.sigla_unidade_medida}</Td>
												<Td alignCenter>{item.status || '-'}</Td>
											</Tr>
										))}
										{!solicitacoes.length &&
								<Tr><Td colSpan={5} alignCenter>Nenhuma solicitação incluída hoje.</Td></Tr>}
									</TBody>
								</Table>
							</ContentCardBody>
						</ContentCard>}
					</>
				) : (
					<div className='alert alert-info'>Use o botão acima para acessar a execução da produção.</div>
				)}
			</Content>
		);
	}
}

const mapStateToProps = state => ({
	aguardando: state.carga.aguardando,
	listaCargas: state.carga.lista,
	listaSolicitacoes: state.solicitacao.lista,
	usuarioCarregado: state.auth.usuarioCarregado,
	getPermissao: state.auth.getPermissao
});

const mapDispatchToProps = dispatch => bindActionCreators({
	getListaCargas,
	getListaSolicitacoes
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
